module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Reset User Password")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "flash-message"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-info'
  }, [_vm._v("NOTE: This will send a reset password email to the user, however this\n          will "), _c('i', [_vm._v("NOT")]), _vm._v(" require the user to enter their PIN, so make sure you have verified their identity.")])]), _vm._v(" "), _c('div', {
    staticClass: "content-centered"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "disabled": _vm.emailSent
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset Password")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c693e6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/users/UserPassword.vue
// module id = 2301
// module chunks = 1